export const API_ERROR_MESSAGES = {
  NETWORK_ERROR: 'Unable to connect to the server. Please check your internet connection.',
  INVALID_CREDENTIALS: 'Invalid email or password.',
  SERVER_ERROR: 'Something went wrong. Please try again later.',
  DEFAULT: 'An error occurred while trying to sign in.'
} as const

export const getErrorMessage = (error: any): string => {
  if (!error) {
    return API_ERROR_MESSAGES.NETWORK_ERROR
  }

  if (error.message) {
    return error.message;
  }

  switch (error.response.status) {
    case 401:
      return API_ERROR_MESSAGES.INVALID_CREDENTIALS
    case 500:
      return API_ERROR_MESSAGES.SERVER_ERROR
    default:
      return error.response.data?.message || API_ERROR_MESSAGES.DEFAULT
  }
}